module.exports = __webpack_public_path__ + "img/hug.3701d080.png";